
import React from 'react';
import {DashboardContainer, Spinner} from "../../funcs/utils";
import { NotificationType } from "../../../lib/proto/notification";
import { Rebalance, render_buttons } from "./rebalance";
import { sprintf } from "sprintf-js";

class SANotification extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.notification.executed.length === 0
      && this.props.notification.queued.length === 0) {
      this.props.loadQueueItems(this.props.queue_types);
    }
    const irr = this.props.irr
    if (!irr.category || !irr.scores) {
      this.props.loadIRRScores();
    }

    if (this.props.args.ids) {
      const ids = this.props.args.ids.split(",");
      const do_csv = {};
      ids.forEach(id => {
        do_csv[id] = 'yes';
      })
      this.setState({ do_csv });
    }
  }

  dump_items = (rebalance_items, do_download_all) => {
    const display_items = [];

    const hr_style = {
      borderTop: "1px black solid",
    }

    if (do_download_all) {
      display_items.push(
        (<div key={"all"}>
            { render_buttons(this) }
        </div>));
    }
    rebalance_items.forEach((item, index) => {
      display_items.push(
        (<hr style={hr_style} key={sprintf("hr_%d", index)}/>));

      if (item.notification_type === NotificationType.REBALANCE_REQUEST.id
        || item.queue_type === "Rebalance2") {
        display_items.push((
          <Rebalance
            notif={item}
            wlf={this.props.app.wlf}
            key={index}
            component={this}
            etf_to_category={this.props.notification.etf_to_category}/>));
      }
    });

    return (
      <div>
        {display_items}
      </div>
    )
  }

  get_notif = (notif_id) => {
    let notif;
    const props = [ 'executed', 'queued' ];

    for (let j=0; j < props.length; j++) {
      const prop = props[j];
      for(let i=0; i < this.props.notification[prop].length; i++) {
        if (this.props.notification[prop][i].id === notif_id) {
          notif = this.props.notification[prop][i];
          break;
        }
      }
      if (notif) {
        break;
      }
    }
    return notif;
  }

  renderNotif = id => {
    const notif = this.get_notif(id);
    const client = this.props.client;

    const item = notif
      ? (<Rebalance
        notif={notif}
        full_detail={false}
        component={this}
        etf_to_category={this.props.notification.etf_to_category}/>)
      : (<div style={{ padding: "2rem"}} align={"center"}>
          <Spinner size={"2rem"}/>
        </div>
      );

    return (
      <div className={"img-col"} id={"sa_symbols"}>
        <DashboardContainer
          client={client}
          title={id}>
          { item }
        </DashboardContainer>
      </div>
    );
  }

  renderSelected(ids) {
    const client = this.props.client;
    const queued = this.props.notification.queued;
    const rebals = [];
    ids.forEach(id => {
      const rebal = queued.find(item => item.id === id);
      if (rebal) {
        rebals.push(rebal);
      }
    })

    return (
      <div className={"img-col"} id={"sa_symbols"}>
        <DashboardContainer
          title={"Rebalances"}
          client={client}>
          { this.dump_items(rebals, true) }
        </DashboardContainer>
      </div>);
    }

  renderAllNotifs = () => {
    const client = this.props.client;
    const loading = this.props.notification.loading;

    return (
      <div className={"img-col"} id={"sa_symbols"}>
        <DashboardContainer
          title={this.props.title + " Queued"}
          spinner={loading}
          client={client}>
          { this.dump_items(this.props.notification.queued, true) }
        </DashboardContainer>
        <DashboardContainer
          title={this.props.title + " Executed"}
          spinner={loading}
          client={client}>
          { /* this.dump_items(this.props.notification.executed, false) */}
        </DashboardContainer>
      </div>
    )
  }

  render = () => {
    const args = this.props.args;
    if (args.id) {
      return this.renderNotif(args.id);
    } else if (args.ids) {
      return this.renderSelected(args.ids.split(","));
    } else {
      return this.renderAllNotifs();
    }
  }
}

export { SANotification };
